export default __webpack_public_path__ + "media/images/mail-cf67261689cd12b7b9cf2026d8333f34.svg";